(function() {
  'use strict';
  
  // Only run on product pages
  if (!document.querySelector('.js-product-json')) {
    return;
  }
  
  // Skip for B2B customers - they have their own price handling
  // Check for B2B indicators: MSRP element or B2B debug panel
  if (document.querySelector('.js-msrp-price, .msrp-price, .b2b-debug-panel')) {
    return;
  }

  // Cache DOM elements and product data
  let productData = null;
  let priceWrapper = null;
  let lastVariantId = null;
  let updateInProgress = false;

  function initializeData() {
    const productJsonScript = document.querySelector('.js-product-json');
    if (!productJsonScript) return false;
    
    try {
      productData = JSON.parse(productJsonScript.textContent);
      priceWrapper = document.querySelector('.price-wrapper');
      return true;
    } catch (e) {
      console.error('DTC Price Fix: Failed to parse product data', e);
      return false;
    }
  }

  function updateCompareAtPrice() {
    // Prevent concurrent updates
    if (updateInProgress) return;
    updateInProgress = true;

    // Get current variant ID
    const variantInput = document.querySelector('.js-variant-input, input[name="id"]');
    if (!variantInput) {
      updateInProgress = false;
      return;
    }
    
    const currentVariantId = parseInt(variantInput.value, 10);
    
    // Skip if same variant
    if (currentVariantId === lastVariantId) {
      updateInProgress = false;
      return;
    }
    lastVariantId = currentVariantId;
    
    // Initialize if needed
    if (!productData && !initializeData()) {
      updateInProgress = false;
      return;
    }
    if (!priceWrapper) {
      updateInProgress = false;
      return;
    }
    
    // Find the current variant
    const currentVariant = productData.variants.find(v => v.id === currentVariantId);
    if (!currentVariant) {
      updateInProgress = false;
      return;
    }
    
    // Use requestAnimationFrame to sync with browser paint
    requestAnimationFrame(() => {
      // Get existing elements
      let compareAtPriceElement = priceWrapper.querySelector('.compare-at-price.js-price');
      const currentPriceElement = priceWrapper.querySelector('.current-price');
      
      // Determine if we should show compare at price
      const shouldShowCompareAt = currentVariant.compare_at_price && 
                                 currentVariant.compare_at_price > currentVariant.price;
      
      if (shouldShowCompareAt) {
        // Create element if it doesn't exist
        if (!compareAtPriceElement) {
          // Find or create SR label
          let srLabel = priceWrapper.querySelector('.sr-only');
          if (!srLabel) {
            srLabel = document.createElement('span');
            srLabel.className = 'sr-only';
            srLabel.textContent = 'Original price:';
            priceWrapper.insertBefore(srLabel, currentPriceElement);
          }
          
          // Create compare at price element
          compareAtPriceElement = document.createElement('s');
          compareAtPriceElement.className = 'compare-at-price js-price';
          priceWrapper.insertBefore(compareAtPriceElement, currentPriceElement);
        }
        
        // Format the price using Shopify's currency
        const currency = window.Shopify?.currency?.active || 'USD';
        const formattedPrice = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: currency,
          minimumFractionDigits: 2
        }).format(currentVariant.compare_at_price / 100);
        
        // Update the price text
        compareAtPriceElement.textContent = formattedPrice;
        compareAtPriceElement.classList.remove('hide');
        compareAtPriceElement.style.display = '';
        
      } else if (compareAtPriceElement) {
        // Hide the compare at price
        compareAtPriceElement.classList.add('hide');
        compareAtPriceElement.style.display = 'none';
      }
      
      updateInProgress = false;
    });
  }

  // Watch for DOM mutations on price elements to sync our updates
  function observePriceChanges() {
    const observer = new MutationObserver((mutations) => {
      // Check if current price was updated
      const priceUpdated = mutations.some(mutation => {
        return mutation.target.classList?.contains('js-price') || 
               mutation.target.classList?.contains('current-price') ||
               (mutation.type === 'characterData' && mutation.target.parentElement?.classList?.contains('current-price'));
      });
      
      if (priceUpdated) {
        // Update compare-at price immediately when current price changes
        updateCompareAtPrice();
      }
    });
    
    if (priceWrapper) {
      observer.observe(priceWrapper, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['class', 'style']
      });
    }
  }

  // Method 1: Listen for option changes
  document.addEventListener('change', function(e) {
    if (e.target.closest('.js-product-option')) {
      // Update immediately on option change
      updateCompareAtPrice();
    }
  });

  // Method 2: Monitor variant input changes
  const variantInput = document.querySelector('.js-variant-input, input[name="id"]');
  if (variantInput) {
    // Watch for value changes
    let lastValue = variantInput.value;
    
    // Use MutationObserver for immediate updates
    const observer = new MutationObserver(() => {
      if (variantInput.value !== lastValue) {
        lastValue = variantInput.value;
        updateCompareAtPrice();
      }
    });
    observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
  }

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initializeData();
      updateCompareAtPrice();
      observePriceChanges();
    });
  } else {
    initializeData();
    updateCompareAtPrice();
    observePriceChanges();
  }
})();
